import React from 'react';

export const TagItem = ({value}) => { 
  return (
    <div className='tag-item'>
      {value}
    </div>
  );
}